var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var transitionDuration = '0.2s';
export var transitionTimingFunction = 'ease-in-out';
export var createTransition = function (_a) {
    var properties = _a.properties, _b = _a.duration, duration = _b === void 0 ? transitionDuration : _b, _c = _a.timingFunction, timingFunction = _c === void 0 ? transitionTimingFunction : _c;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: ", ";\n"], ["\n  transition: ", ";\n"])), properties
        .map(function (property) { return "".concat(property, " ").concat(duration, " ").concat(timingFunction); })
        .join(', '));
};
var templateObject_1;
